export const GTM_ID = 'GTM-PCLHVNX';
export const GA4_ID = 'G-G9LY2L7G75';
export const pageview = (url) => {
    window.dataLayer.push({
        event: 'pageview',
        page: url
    });
};
